import React from "react";
import { Button } from "./button";
import { useNavigate } from "react-router-dom";

interface FeaturedToolkitProps {
  id: string;
  title: string;
  type: 'lolbas' | 'gtfobins' | 'wadcoms' | 'reverse-shell' | 'osint' | 'hunting-toolkit';
  description?: string;
  className?: string;
}

const FeaturedToolkit: React.FC<FeaturedToolkitProps> = ({ id, title, type, description, className = '' }) => {
  const navigate = useNavigate();

  const getToolkitPath = (toolkitType: string) => {
    switch (toolkitType) {
      case 'lolbas':
        return '/toolkits/lolbas';
      case 'gtfobins':
        return '/toolkits/gtfobins';
      case 'wadcoms':
        return '/toolkits/wadcoms';
      case 'reverse-shell':
        return '/toolkits/reverse-shell';
      case 'osint':
        return '/toolkits/osint';
      case 'hunting-toolkit':
        return '/toolkits/hunting-toolkit';
      default:
        return '/toolkits';
    }
  };

  const getToolkitIcon = (toolkitType: string) => {
    switch (toolkitType) {
      case 'lolbas':
        return "🖥️";
      case 'gtfobins':
        return "🐧";
      case 'wadcoms':
        return "🪟";
      case 'reverse-shell':
        return "🔄";
      case 'osint':
        return "🔍";
      case 'hunting-toolkit':
        return "🎯";
      default:
        return "🛠️";
    }
  };

  const getTypeLabel = () => {
    switch (type) {
      case 'lolbas':
        return 'LOLBAS Toolkit';
      case 'gtfobins':
        return 'GTFOBins Toolkit';
      case 'wadcoms':
        return 'WADComs Toolkit';
      case 'reverse-shell':
        return 'Reverse Shell Toolkit';
      case 'osint':
        return 'OSINT Toolkit';
      case 'hunting-toolkit':
        return 'Hunting Toolkit';
      default:
        return 'Toolkit';
    }
  };

  return (
    <div className={`bg-[#f0f9e3] border-2 border-[#daed6e] rounded-[20px] p-5 shadow-sm hover:shadow-md transition-shadow relative ${className}`}>
      {/* Star positioned on the upper left corner */}
      <span 
        className="absolute -top-2 -left-2 text-lg flex items-center justify-center" 
        aria-label="Featured Toolkit"
      >
        ⭐
      </span>
      <div className="flex justify-between items-start">
        <div>
          <h3 className="font-['Space_Grotesk'] font-bold text-lg text-black mb-1 flex items-center gap-2">
            <span className="text-xl">{getToolkitIcon(type)}</span> {title}
          </h3>
          {description && (
            <p className="text-sm text-black opacity-80 mb-3">
              {description}
            </p>
          )}
          <div className="inline-block px-3 py-1 bg-[#daed6e] rounded-full text-xs font-medium">
            {getTypeLabel()}
          </div>
        </div>
        <Button 
          className="bg-[#daed6e] hover:bg-[#c5d85c] text-black font-medium px-4 h-10"
          onClick={() => navigate(getToolkitPath(type))}
        >
          Explore Toolkit
        </Button>
      </div>
    </div>
  );
};

export default FeaturedToolkit; 